import React, { useState } from 'react';
import PageWrapper from '../components/PageWrapper';

export const News = ({ onNavigate }) => (
  <PageWrapper onNavigate={onNavigate} showFullFooter>
    <div className="page-hero">
      <p className="section-label">Insights</p>
      <h1>News & Blog</h1>
      <p>Latest insights from the frontlines of African investment and development.</p>
    </div>
    <section className="section">
      <div className="container">
        <div className="grid-3">
          {[
            { icon: '⛏', tag: 'Mining', title: 'Africa\'s Mining Sector Sees Record FDI in 2024', desc: 'Foreign direct investment into African mining hit a decade high last year, with West Africa leading the charge in gold and bauxite exploration.', date: 'March 2025' },
            { icon: '☀️', tag: 'Renewables', title: 'Solar Capacity in Sub-Saharan Africa Doubles in Two Years', desc: 'Driven by falling costs and rising demand, solar installations across the continent have seen an unprecedented growth trajectory.', date: 'February 2025' },
            { icon: '◆', tag: 'Diamonds', title: 'Kimberley Process Reforms Strengthen Ethical Diamond Trade', desc: 'New amendments to the Kimberley Process Certification Scheme are set to further enhance transparency in the diamond supply chain.', date: 'January 2025' },
            { icon: '🌿', tag: 'Eco Tourism', title: 'Eco-Tourism in East Africa: A Billion-Dollar Opportunity', desc: 'East Africa\'s tourism sector is recovering strongly post-pandemic, with eco-tourism and conservation travel leading the rebound.', date: 'December 2024' },
            { icon: '🌍', tag: 'Investment', title: 'Varahi Facilitates $200M Mining Deal in Ghana', desc: 'Varahi Global Consulting successfully facilitated a landmark investment deal connecting a European mining firm with Ghana\'s Ashanti region.', date: 'November 2024' },
            { icon: '⚡', tag: 'Energy', title: 'Off-Grid Solar: Transforming Rural African Economies', desc: 'Distributed solar systems are revolutionising agricultural productivity and education outcomes across remote African communities.', date: 'October 2024' },
          ].map(n => (
            <div key={n.title} className="news-card">
              <div className="news-img" style={{ fontSize: '3rem' }}>{n.icon}</div>
              <div className="news-body">
                <div className="news-tag">{n.tag}</div>
                <h4>{n.title}</h4>
                <p>{n.desc}</p>
                <div className="news-date">{n.date}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </PageWrapper>
);

export const Gallery = ({ onNavigate }) => (
  <PageWrapper onNavigate={onNavigate} showFullFooter>
    <div className="page-hero">
      <p className="section-label">Visual Story</p>
      <h1>Gallery</h1>
      <p>Moments from our work across the African continent.</p>
    </div>
    <section className="section">
      <div className="container">
        <div className="gallery-grid">
          {[['⛏', 'Mining Operations'], ['◆', 'Diamond Sourcing'], ['☀️', 'Solar Projects'], ['🐘', 'Wildlife & Conservation'], ['🌍', 'Africa Operations'], ['🤝', 'Community Engagement'], ['🏔️', 'Eco Tourism Sites'], ['💨', 'Wind Energy'], ['👥', 'Team in Field'], ['🦁', 'Wildlife Safaris'], ['🌿', 'Forest Conservation'], ['💧', 'Hydro Power']].map(([icon, label]) => (
            <div key={label} className="gallery-item">
              <div className="gallery-icon-lg">{icon}</div>
              <span className="gallery-label">{label}</span>
            </div>
          ))}
        </div>
        <p style={{ textAlign: 'center', color: 'var(--muted)', marginTop: '2rem', fontSize: '.9rem' }}>Contact us to receive our full media kit and project photography.</p>
      </div>
    </section>
  </PageWrapper>
);

export const Careers = ({ onNavigate }) => (
  <PageWrapper onNavigate={onNavigate} showFullFooter>
    <div className="page-hero">
      <p className="section-label">Join Us</p>
      <h1>Careers</h1>
      <p>Build your career at the intersection of global finance and African opportunity.</p>
    </div>
    <section className="section">
      <div className="container">
        <div className="grid-2" style={{ alignItems: 'start', marginBottom: '4rem', gap: '3rem' }}>
          <div>
            <p className="section-label">Why Join Varahi?</p>
            <h2 className="section-title">Grow With Africa</h2>
            <div className="gold-line" />
            <ul className="service-list">
              {['Work across 18 African countries on high-impact projects', 'Join a diverse, multilingual team of 80+ professionals', 'Competitive compensation with performance bonuses', 'Continuous learning and field exposure opportunities', 'Be part of transforming Africa\'s economic landscape'].map(i => <li key={i}>{i}</li>)}
            </ul>
          </div>
          <div style={{ background: '#071a12', padding: '2.5rem' }}>
            <h4 style={{ color: '#c9a84c', fontFamily: "'Playfair Display', serif", marginBottom: '1rem', fontSize: '1.3rem' }}>Apply Today</h4>
            <p style={{ color: '#a8c4b4', fontSize: '.9rem', lineHeight: 1.75, marginBottom: '1.25rem' }}>Send your CV and cover letter to our careers team. We review applications on a rolling basis.</p>
            <p style={{ color: '#fff', fontSize: '.9rem', marginBottom: '.5rem' }}>📧 careers@varahiconsulting.com</p>
            <p style={{ color: '#a8c4b4', fontSize: '.82rem' }}>Monday – Friday: 9:00 AM – 6:00 PM IST</p>
          </div>
        </div>
        <h3 style={{ fontFamily: "'Playfair Display', serif", color: 'var(--green-dark)', fontSize: '1.6rem', marginBottom: '1.5rem' }}>Open Positions</h3>
        {[
          { title: 'Senior Mining Consultant', tags: ['Hyderabad / Field', 'Full-time', 'Mining'] },
          { title: 'Renewable Energy Project Manager', tags: ['Kenya / Remote', 'Full-time', 'Energy'] },
          { title: 'Diamond Trade Analyst', tags: ['Hyderabad', 'Full-time', 'Diamonds'] },
          { title: 'Eco-Tourism Development Associate', tags: ['Nairobi', 'Full-time', 'Tourism'] },
          { title: 'Africa Operations Coordinator', tags: ['Various', 'Full-time', 'Operations'] },
          { title: 'Financial Analyst — Africa Investments', tags: ['Hyderabad', 'Full-time', 'Finance'] },
        ].map(job => (
          <div key={job.title} className="job-card">
            <div>
              <div className="job-title">{job.title}</div>
              <div className="job-tags">{job.tags.map(t => <span key={t} className="job-tag">{t}</span>)}</div>
            </div>
            <button className="btn-gold" style={{ padding: '.55rem 1.3rem', fontSize: '.72rem' }}>Apply</button>
          </div>
        ))}
      </div>
    </section>
  </PageWrapper>
);

export const Contact = ({ onNavigate }) => {
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', org: '', interest: 'Mining Consultancy', message: '' });
  const [sent, setSent] = useState(false);

  const handle = e => setForm({ ...form, [e.target.name]: e.target.value });
  const submit = () => { if (form.firstName && form.email) setSent(true); };

  return (
    <PageWrapper onNavigate={onNavigate} showFullFooter>
      <div className="page-hero">
        <p className="section-label">Get In Touch</p>
        <h1>Contact Us</h1>
        <p>We'd love to discuss how Varahi can support your Africa ambitions.</p>
      </div>
      <section className="section">
        <div className="container">
          <div className="grid-2" style={{ maxWidth: '1000px', margin: '0 auto', alignItems: 'start' }}>
            <div className="contact-info-box">
              <h3>Reach Us Directly</h3>
              {[
                ['📧', 'General Enquiries', 'info@varahiconsulting.com'],
                ['📧', 'Careers', 'careers@varahiconsulting.com'],
                ['📧', 'Operations', 'operations@varahiconsulting.com'],
                ['📍', 'Head Office', 'Orbit Building, 5th Floor, AWFIS\nRaidurg, Hyderabad\nTelangana, India'],
                ['🌍', 'Africa Offices', 'Nairobi, Kenya\nAccra, Ghana\nGaborone, Botswana'],
              ].map(([icon, label, value]) => (
                <div key={label} className="contact-row">
                  <span className="contact-icon">{icon}</span>
                  <div>
                    <span className="contact-label">{label}</span>
                    <span className="contact-value">{value.split('\n').map((l, i) => <span key={i} style={{ display: 'block' }}>{l}</span>)}</span>
                  </div>
                </div>
              ))}
              <div style={{ borderTop: '1px solid rgba(201,168,76,0.2)', marginTop: '1.5rem', paddingTop: '1.25rem' }}>
                <span className="contact-label" style={{ marginBottom: '.6rem' }}>Business Hours</span>
                <span className="contact-value" style={{ display: 'block' }}>Monday – Friday: 9:00 AM – 6:00 PM IST</span>
                <span className="contact-value" style={{ display: 'block' }}>Saturday: 9:00 AM – 1:00 PM IST</span>
              </div>
            </div>
            <div className="contact-form-box">
              {sent ? (
                <div style={{ textAlign: 'center', padding: '3rem 1rem' }}>
                  <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
                  <h3 style={{ fontFamily: "'Playfair Display', serif", color: 'var(--green-dark)', marginBottom: '.75rem' }}>Message Sent!</h3>
                  <p style={{ color: 'var(--muted)' }}>Thank you for reaching out. Our team will get back to you within 24 hours.</p>
                </div>
              ) : (
                <>
                  <h3>Send a Message</h3>
                  <div className="form-row">
                    <div className="form-group"><label>First Name</label><input name="firstName" value={form.firstName} onChange={handle} placeholder="John" /></div>
                    <div className="form-group"><label>Last Name</label><input name="lastName" value={form.lastName} onChange={handle} placeholder="Smith" /></div>
                  </div>
                  <div className="form-group"><label>Email Address</label><input name="email" type="email" value={form.email} onChange={handle} placeholder="john@company.com" /></div>
                  <div className="form-group"><label>Organisation</label><input name="org" value={form.org} onChange={handle} placeholder="Your Company" /></div>
                  <div className="form-group">
                    <label>Area of Interest</label>
                    <select name="interest" value={form.interest} onChange={handle}>
                      {['Mining Consultancy', 'Diamond Services', 'Renewable Energy', 'Eco Tourism', 'Africa Market Entry', 'Other'].map(o => <option key={o}>{o}</option>)}
                    </select>
                  </div>
                  <div className="form-group"><label>Message</label><textarea name="message" value={form.message} onChange={handle} placeholder="Tell us about your project or enquiry..." /></div>
                  <button className="btn-gold" style={{ width: '100%', padding: '1rem' }} onClick={submit}>Send Message</button>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </PageWrapper>
  );
};
